import React from 'react'
import { ScreenOverlay } from '../../widgets'
import { HorizontalLoader } from '../../widgets/Loader'

const MapOverlay = ({ show, text }) => {
    return (
        <ScreenOverlay show={show}>
            <ScreenOverlay.Content>
                <ScreenOverlay.Text>{text}</ScreenOverlay.Text>
                <HorizontalLoader />
            </ScreenOverlay.Content>
        </ScreenOverlay>
    )
}

export default MapOverlay
